import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {mode, className, firstSize, lastSize, _resizing} = self.get();

const classNameObj = {
    'k-split': true,
    [`k-${mode}`]: true,
    [className]: className,
    'k-first-auto': firstSize === 'auto',
    'k-last-auto': lastSize === 'auto',
    'k-resizing': _resizing,
};

const stylePropName = mode === 'horizontal' ? 'width' : 'height';

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this)
    }, [
        h('div', {
            'style': function() {try {return ({[stylePropName]: firstSize} )} catch(e) {_e(e)}}.call($this)
        }, (_blocks['first'] = function(parent) {
            return null;
        }) && (__blocks['first'] = function(parent) {
            var args = arguments;
            return blocks['first'] ? blocks['first'].apply($this, [function() {
                return _blocks['first'].apply($this, args);
            }].concat(__slice.call(args, 1))) : _blocks['first'].apply($this, args);
        }) && __blocks['first'].apply($this, [__noop]), 'k-first', null, function(i) {widgets['first'] = i}),
        h('div', {
            'ev-mousedown': function() {try {return (self._onMoveStart )} catch(e) {_e(e)}}.call($this)
        }, (_blocks['drag'] = function(parent) {
            return h('div', null, h('div', null, null, 'k-drag-lines'), 'k-line');
        }) && (__blocks['drag'] = function(parent) {
            var args = arguments;
            return blocks['drag'] ? blocks['drag'].apply($this, [function() {
                return _blocks['drag'].apply($this, args);
            }].concat(__slice.call(args, 1))) : _blocks['drag'].apply($this, args);
        }) && __blocks['drag'].apply($this, [__noop]), 'k-line-wrapper'),
        h('div', {
            'style': function() {try {return ({[stylePropName]: lastSize} )} catch(e) {_e(e)}}.call($this)
        }, (_blocks['last'] = function(parent) {
            return null;
        }) && (__blocks['last'] = function(parent) {
            var args = arguments;
            return blocks['last'] ? blocks['last'].apply($this, [function() {
                return _blocks['last'].apply($this, args);
            }].concat(__slice.call(args, 1))) : _blocks['last'].apply($this, args);
        }) && __blocks['last'].apply($this, [__noop]), 'k-last', null, function(i) {widgets['last'] = i})
    ], _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}